// import: styles
import { Box } from '@mui/material';

// import: assets
// import: constants
import BaseTypography from 'core/components/typography/BaseTypography';
import { toastConfig } from 'core/config/ToastConfig';
import { toastStyles } from 'core/layouts/components/toast/ToastStyles';
import appTheme from 'core/layouts/ui-blocks/AppTheme';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import React from 'react';
import { toast } from 'react-toastify';

// import: utils
// import: services
// import: redux
// import: components
// import: lazy load components

function Msg(props) {
	const { msgConfig } = props;

	return (
		<Box id="msg" sx={toastStyles.msg}>
			<Box id="icon" sx={toastStyles.icon}>
				{msgConfig?.icon}
			</Box>
			<Box id="msg" sx={toastStyles.flexCol}>
				<BaseTypography
					variant="b2_caption"
					styles={[appTheme.typography.t2_medium, { color: colorPalette.dark5 }]}
				>
					{msgConfig?.title}
				</BaseTypography>
				{msgConfig?.subtitle && (
					<BaseTypography
						variant="b1_medium"
						styles={[appTheme.typography.b2_caption, { color: colorPalette.grey600 }]}
					>
						{msgConfig?.subtitle}
					</BaseTypography>
				)}
			</Box>
		</Box>
	);
}

export const sendToast = (toastType, title = '') => {
	const config = toastConfig[toastType];
	if (title !== '') {
		config.title = title;
	}

	toast.info(<Msg msgConfig={config} />);
};
